import { useState } from 'react';
import { features } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function FeatureGrid() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section id="shen" className="bg-background-100/60 scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          kicker="深度解析瓜"
          title="不止吃瓜，也把瓜掰开看"
          desc="编辑部与观察员带来的行业观察，用理性的视角聊聊热瓜背后正在发生的改变。"
          align="center"
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => {
            const isOpen = openId === f.id;
            return (
              <article
                key={f.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-shadow hover:border-accent-200"
              >
                <div className="relative aspect-[3/2] w-full overflow-hidden">
                  <img
                    src={f.img}
                    alt={`深度解析：${f.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute left-3 top-3 flex items-center gap-2">
                    <span className="rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-primary-700 backdrop-blur">
                      {f.category}
                    </span>
                    {f.hot ? (
                      <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-bold text-foreground-950">
                        <i className="ri-fire-fill h-3 w-3" />
                        热读
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">{f.title}</h3>
                  <p className="mt-2 text-sm font-medium text-primary-600">{f.lead}</p>
                  <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">{f.body}</p>
                  {isOpen ? (
                    <p className="mt-3 rounded-xl bg-accent-50 p-4 text-sm leading-relaxed text-foreground-700">
                      早报延伸：无论行业如何变化，能被时间留下的，永远是踏实做内容、真诚对待观众的那一方。瓜田里既有热闹，也有值得被看见的长期主义。
                    </p>
                  ) : null}
                  <div className="mt-auto flex items-center gap-3 border-t border-background-100 pt-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-quill-pen-line h-3.5 w-3.5 text-accent-700" />
                      {f.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line h-3.5 w-3.5" />
                      约 {f.readTime}
                    </span>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : f.id)}
                      className="ml-auto inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-50 px-3 py-1.5 font-semibold text-primary-700 transition-colors hover:bg-primary-100"
                    >
                      {isOpen ? '收起' : '继续阅读'}
                      <i className={`${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-right-s-line'} h-4 w-4`} />
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}